<template>
  <div>
    <SpGlobalAlertWarning
      info="已经生成的文件只保留30分钟，请及时下载"
      class-name="custom_alert"
    />

    <SpCardContent class="content">
      <!-- 查询区 -->
      <div class="search-btn f-search-block">
        <div class="search-items">
          <div class="field-item">
            <div class="field-item-label">
              文件类别：
            </div>
            <div class="field-item-control">
              <el-select
                v-model="params.files_type"
                class="select"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in fileTypeList"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </div>
          </div>
        </div>
        <div class="search-btns">
          <el-button
            type="primary"
            @click="haddleSearch"
          >
            查询
          </el-button>
        </div>
      </div>

      <div class="f-table-block">
        <el-table
          :data="tableData"
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column
            prop="file_name"
            label="文件名称"
          />
          <el-table-column
            prop="handle_done_at"
            label="文件生成日期"
          />
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="download(scope.row)"
              >
                下载
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页器 -->
        <el-pagination
          class="table-pagination"
          background
          :current-page="params.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="params.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total_count"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </SpCardContent>
  </div>
</template>

<script>
import { getFilesList } from '@/api/staffManagement/exportList'

export default {
  data () {
    return {
      tableData: [],
      params: {
        type: 1, //需要查询的模块标识  [导购：1] |默认1
        files_type: 6, //所查询的导购模块下的文件类别 [1:业绩excel  2:导购码zip] |默认1
        page: 1,
        page_size: 20
      },
      total_count: 0,
      fileTypeList: []
    }
  },
  created () {
    this.getFileTypes()
  },
  mounted () {
    // 根据页面来源获取当前选中项
    if (this.$route.query && this.$route.query.filestype) {
      this.params.files_type = Number(this.$route.query.filestype)
    }
    this.getList()
  },
  methods: {
    // 获取列表
    async getList () {
      const data = await getFilesList(this.params)
      if (data) {
        this.tableData = data.list
        this.total_count = data.total_count
      }
    },
    //获取文件类型列表
    async getFileTypes () {
      const data = await this.$api.file.getFileTypes()
      this.fileTypeList = data || []
      // 处理兼容
      if (this.fileTypeList.findIndex((v) => v.code === this.params.files_type) === -1) {
        this.params.files_type = null
      }
      console.log('[获取文件类型列表]', data)
    },
    // 下载
    download (item) {
      const a = document.createElement('a')
      a.href = item.relative_path
      a.download = item.file_name
      a.click()
    },

    // 列表分页
    handleSizeChange (val) {
      this.params.page = 1
      this.params.page_size = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getList()
    },

    haddleSearch () {
      this.params.page = 1
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin-top: 20px;
}
</style>
